import React, { useEffect, useState } from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { matchesBoolean } from "LIB/filters";
import {
  Pagination,
  SearchFilter,
  FilterSelect,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { NoteTooltip, Search } from "MODULES/shared/components";
import api from "APP_ROOT/api";
import { useCurrentUser } from "APP_ROOT/hooks";
import Table from "./Table";
import NewUser from "./NewUser";
import { pagination } from "../../pagination";

const filters = [
  {
    label: "Show All Users",
    filters: { all_roles: true, active: true }
  },
  {
    label: "Show Admin",
    filters: { admin_role: true }
  },
  {
    label: "Show Accounting",
    filters: { accounting_role: true }
  },
  {
    label: "Show Quality Control",
    filters: { quality_control_role: true }
  },
  {
    label: "Show Repair",
    filters: { repair_role: true }
  },
  {
    label: "Show Sales",
    filters: { sales_role: true }
  },
  {
    label: "Show Warehouse",
    filters: { warehouse_role: true }
  },
  {
    label: "Show Active",
    filters: { active: true }
  },
  {
    label: "Show Deactivated",
    filters: { active: false }
  }
];

const Note = () => (
  <NoteTooltip
    note="You have reached your seat limit."
    icon="fa-info-circle"
    color="#545454"
  />
);

const filterTags = [
  {
    label: "All Roles",
    key: "all_roles",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Admin",
    key: "admin_role",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Active",
    key: "active",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Accounting",
    key: "accounting_role",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Deactivated",
    key: "active",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Quality Control",
    key: "quality_control_role",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Repair",
    key: "repair_role",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Sales",
    key: "sales_role",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Warehouse",
    key: "warehouse_role",
    matchesTarget: matchesBoolean(true)
  }
];

function UsersSearch({ pushHistory }) {
  const [activeUsers, setActiveUsers] = useState(0);
  const currentUser = useCurrentUser();
  useEffect(() => {
    api.users
      .search({ active: true })
      .then(({ data: { total_count: count } }) => {
        setActiveUsers(count);
      });
  });

  const disableNewUsers = get(currentUser, "tenant.seats", 0) <= activeUsers;

  return (
    <Search search={pagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Type a user's name or email address..."
                submitOnSingleResult={r => pushHistory(`/users/${r.uuid}`)}
              />
              <FilterSelect {...searchProps} filters={filters} right />
              <NewUser
                disabled={disableNewUsers}
                text={
                  disableNewUsers ? [<Note />, "Create New"] : "  Create New"
                }
              />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title="Users"
            filters={filterTags}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

UsersSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(UsersSearch);



// WEBPACK FOOTER //
// ./app/modules/users/components/Search/Search.jsx